import React, { useState } from 'react';
import {CircularProgress, Modal} from "@mui/material";
import {useStorageState} from "../storage-state/useStorageState";

export const LoadingContext = React.createContext(undefined);

export const LoadingContextProvider = ({ children }) => {
    const [loadingQueue, setLoadingQueue] = useStorageState('isLoading', []);
    const [r, refresh] = useState(false);

    const setIsLoading = (isLoading, loadingCallId) => {
        if (!loadingQueue) return;

        const id = loadingCallId;
        const foundIndex = loadingQueue?.findIndex((q) => q === id);
        const updatedQueue = loadingQueue;
        if (isLoading && foundIndex === -1) updatedQueue?.push(id);
        else if (!isLoading && foundIndex !== -1) updatedQueue?.splice(foundIndex, 1);
        setLoadingQueue(updatedQueue);
        refresh(!r);
    };

    const loadingBody = (
        <Modal
            className="loading"
            open={true}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999999 }}
            disableAutoFocus={true}
        >
            <CircularProgress color="primary" />
        </Modal>
    );

    const value = {
        isLoading: loadingQueue ? loadingQueue.length > 0 : false,
        setIsLoading,
    };

    return (
        <LoadingContext.Provider value={value}>
            <>
                {children}
                {value.isLoading && loadingBody}
            </>
        </LoadingContext.Provider>
    );
};
